module.exports = "/public/images/tours/calculationUnitAdmin/actions.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/tours/calculationUnitAdmin/actions.png
// module id = 2089
// module chunks = 7